import React from 'react';

const DialogueModal = ({ isOpen, toggle, onClose, npc, onComplete }) => {
  const closeModal = toggle || onClose || (() => {});

  const handleComplete = () => {
    if (onComplete && typeof onComplete === 'function') {
      onComplete(npc);
    }
    closeModal();
  };

  const handleSecondary = () => {
    if (npc?.onSecondary && typeof npc.onSecondary === 'function') {
      npc.onSecondary(npc);
    }
    closeModal();
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 2000,
          pointerEvents: "all",
        }}
        onClick={(e) => {
          e.stopPropagation();
          closeModal();
        }}
      />

      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(420px, calc(100vw - 32px))",
          background: "linear-gradient(145deg, #2d3748, #1a202c)",
          borderRadius: "8px",
          padding: "14px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          zIndex: 2001,
          color: "#fff",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
            paddingBottom: 10,
            marginBottom: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div
              style={{
                width: 3,
                height: 14,
                background: "linear-gradient(135deg, #667eea, #764ba2)",
                borderRadius: 2,
              }}
            />
            <div style={{ fontSize: 14, fontWeight: 700, letterSpacing: 0.3 }}>
              {npc?.name || "NPC"}
            </div>
          </div>

          <button
            onClick={closeModal}
            style={{
              background: "rgba(255, 255, 255, 0.06)",
              border: "1px solid rgba(255, 255, 255, 0.12)",
              color: "rgba(255, 255, 255, 0.9)",
              width: 28,
              height: 24,
              borderRadius: 6,
              cursor: "pointer",
              fontSize: 16,
              lineHeight: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              opacity: 0.9,
            }}
            aria-label="Close"
            title="Close"
          >
            ✕
          </button>
        </div>

        <div style={{ fontSize: 13, lineHeight: 1.35, color: "#e2e8f0" }}>
          {npc?.dialogue || "Hello there!"}
        </div>

        {npc?.image && (
          <div style={{ marginTop: 12, display: "flex", justifyContent: "center" }}>
            <img
              src={npc.image}
              alt={npc.name || 'NPC'}
              style={{ maxWidth: 120, maxHeight: 120, imageRendering: 'pixelated' }}
            />
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
            marginTop: 14,
          }}
        >
          {npc?.secondaryButtonText && npc?.onSecondary && (
            <button
              onClick={handleSecondary}
              style={{
                background: "linear-gradient(to bottom, #4a5568, #2d3748)",
                color: "#fff",
                border: "1px solid #1a202c",
                padding: "8px 14px",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: "600",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
              }}
            >
              {npc.secondaryButtonText}
            </button>
          )}

          <button
            onClick={handleComplete}
            style={{
              background: "linear-gradient(135deg, #667eea, #764ba2)",
              color: "#fff",
              border: "1px solid #4c366b",
              padding: "8px 14px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "600",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
            }}
          >
            {npc?.buttonText || 'Close'}
          </button>
        </div>
      </div>
    </>
  );
};

export default DialogueModal;
